import {
  NgModule,
  APP_INITIALIZER,
  Optional,
  ModuleWithProviders,
  SkipSelf,
  ErrorHandler,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServicesModule } from './services/services.module';
import { EnvironmentFactory } from './environment/environment.factory';
import { EnvironmentService } from './environment/environment.service';
import { EncDecService } from './utils/enc-dec.service';
import { provideNgxWebstorage, withLocalStorage, withSessionStorage,withNgxWebstorageConfig  } from 'ngx-webstorage';
import { GlobalErrorHandler } from './error/global-error-handler';

@NgModule({
  imports: [
    CommonModule,
    ServicesModule,
   ],
  providers: [
    provideNgxWebstorage(
      withNgxWebstorageConfig({prefix:'', separator:'', caseSensitive:false}),
        withLocalStorage(), withSessionStorage()),
    EncDecService,
    {
      provide: APP_INITIALIZER,
      useFactory: EnvironmentFactory,
      deps: [EnvironmentService],
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    }
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only'
      );
    }
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
    };
  }
}
